import React, {useEffect, useState} from 'react'
import axios from 'axios'
import { Col, Row } from 'react-bootstrap'
import Container from 'react-bootstrap/esm/Container';
import { useParams, useSearchParams } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import BackArrow from '../../components/BackArrow/BackArrow';
import PaginationComponent from '../../components/Pagination/Pagination';
import SpinnerComponents from '../../components/Spinner/SpinnerComponents';
import './ShowPage.css';

const ShowPage = () => {
    let { id } = useParams();
    const [searchParams] = useSearchParams();
    const videoId = searchParams.get('video'); // Get video ID from query params

    const [show, setShow] = useState(null);
    const [videos, setVideos] = useState([]);
    const [featuredVideo, setFeaturedVideo] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const itemsPerPage = 6;
    const navigate = useNavigate();

    const goBack = () => {
        navigate('/shows');
    }

    useEffect(() => {
        // Fetch the show details from the API using the ID
        const fetchShowDetails = async () => {
            try {
                const response = await axios.get(`https://nastaanaisie.pythonanywhere.com/api/shows/${id}/`);
                console.log("Single Show", response.data);
                setShow(response.data);
            } catch (error) {
                console.error('Error fetching the show details:', error);
            }
        };

        fetchShowDetails();

        const fetchVideos = async () => {
            try {
                const res = await axios.get('https://nastaanaisie.pythonanywhere.com/api/videos/');
                console.log("videos", res.data.results);

                let mydata = res.data.results;
                let infoVideo = mydata.filter((data) => {
                    return data.episode.show == id;
                });

                console.log("info", infoVideo);
                setVideos(infoVideo);

                // Set featured video - either from query param or first video
                if (videoId) {
                    const selectedVideo = infoVideo.find(v => v.id == videoId);
                    if (selectedVideo) {
                        setFeaturedVideo(selectedVideo);
                    } else if (infoVideo.length > 0) {
                        setFeaturedVideo(infoVideo[0]);
                    }
                } else if (infoVideo.length > 0) {
                    setFeaturedVideo(infoVideo[0]);
                }

                setLoading(false);
            } catch (error) {
                console.error('Error fetching videos:', error);
                setLoading(false);
            }
        };

        fetchVideos();
    }, [id, videoId]);

    const handleVideoClick = (video) => {
        setFeaturedVideo(video);
        // Update URL without reload
        navigate(`/shows/${id}?video=${video.id}`, { replace: true });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Calculate pagination
    const totalItems = videos.length;
    const totalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 0;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = videos.length > 0 ? videos.slice(indexOfFirstItem, indexOfLastItem) : [];

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="show-page">
            <Container>
                <BackArrow buttonText="Back To Shows" handleBack={goBack}/>

                {loading ? (
                    <div className="show-loading">
                        <SpinnerComponents />
                    </div>
                ) : (
                    <>
                        {/* Show Header */}
                        {show && (
                            <div className="show-header">
                                {show.Image && (
                                    <img src={show.Image} alt={show.title} className="show-header-image" />
                                )}
                                <div className="show-header-content">
                                    <h1 className="show-title">{show.title}</h1>
                                    {show.description && (
                                        <p className="show-description">{show.description}</p>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Featured Video Section */}
                        {featuredVideo && (
                            <div className="featured-video-section">
                                <h2 className="section-title">Now Playing</h2>
                                <div className="featured-video-wrapper">
                                    <div className="video-container">
                                        <iframe 
                                            src={featuredVideo.video_url}
                                            title={featuredVideo.title}
                                            className="featured-video-player"
                                            allowFullScreen
                                            frameBorder="0"
                                        ></iframe>
                                    </div>
                                    <div className="featured-video-info">
                                        <h3 className="featured-video-title">{featuredVideo.title}</h3>
                                        {featuredVideo.episode && featuredVideo.episode.show && (
                                            <p className="featured-video-show">{featuredVideo.episode.show.title}</p>
                                        )}
                                        {featuredVideo.episode && (
                                            <span className="featured-video-episode">
                                                Episode {featuredVideo.episode.episode_number || 'N/A'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Episodes Grid */}
                        {videos.length > 0 && (
                            <div className="episodes-section">
                                <h2 className="section-title">All Episodes</h2>
                                <Row className="episodes-grid">
                                    {currentItems.map(item => (
                                        <Col xs={12} sm={6} md={4} lg={4} key={item.id} className="episode-col">
                                            <div 
                                                className={`episode-card ${featuredVideo && featuredVideo.id === item.id ? 'active' : ''}`}
                                                onClick={() => handleVideoClick(item)}
                                            >
                                                <div className="episode-video-wrapper">
                                                    <iframe 
                                                        src={item.video_url}
                                                        title={item.title}
                                                        className="episode-video"
                                                        frameBorder="0"
                                                    ></iframe>
                                                    <div className="episode-overlay">
                                                        <div className="play-icon-episode">▶</div>
                                                    </div>
                                                </div>
                                                <div className="episode-info">
                                                    <h6 className="episode-title">{item.title}</h6>
                                                    {item.episode && (
                                                        <span className="episode-number">
                                                            Episode {item.episode.episode_number || 'N/A'}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>

                                {/* Pagination */}
                                {totalPages > 1 && (
                                    <div className="episodes-pagination">
                                        <PaginationComponent
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {videos.length === 0 && !loading && (
                            <div className="no-episodes">
                                <p>No episodes available for this show.</p>
                            </div>
                        )}
                    </>
                )}
            </Container>
        </div>
    );
}

export default ShowPage;
